import type { DropfrontCardId } from "../../data/dropfront-catalog";

/** SceneKey-style event discriminants — Find All References / rename via DfEvent.*. */
export const DfEvent = {
  Toast: "toast",
  PodFall: "pod_fall",
  Land: "land",
  Shot: "shot",
  Hit: "hit",
  Destroy: "destroy",
  Supply: "supply",
  Beacon: "beacon",
  DropFail: "drop_fail",
  Won: "won",
  Lost: "lost",
} as const;

export type DfEventType = (typeof DfEvent)[keyof typeof DfEvent];

export const DfPhase = {
  Playing: "playing",
  Paused: "paused",
  Won: "won",
  Lost: "lost",
} as const;

export type Phase = (typeof DfPhase)[keyof typeof DfPhase];

export const DfDropReason = {
  NoCard: "no_card",
  Insufficient: "insufficient",
  Blocked: "blocked",
  Hazard: "hazard",
  Oob: "oob",
} as const;

export type DfDropReason = (typeof DfDropReason)[keyof typeof DfDropReason];

export type SimEvent =
  | {
      type: typeof DfEvent.Toast;
      messageKey: string;
      amount?: number;
    }
  | {
      type: typeof DfEvent.PodFall;
      id: string;
      x: number;
      y: number;
      cardId: DropfrontCardId;
    }
  | { type: typeof DfEvent.Land; id: string; x: number; y: number }
  | {
      type: typeof DfEvent.Shot;
      fromId: string;
      toId: string;
      x0: number;
      y0: number;
      x1: number;
      y1: number;
      role: string;
      delivery: "arc" | "bolt" | "pulse";
      attackId: string;
      aoe?: boolean;
    }
  | {
      type: typeof DfEvent.Hit;
      id: string;
      toId: string;
      x: number;
      y: number;
      damage: number;
      role?: string;
      /** Victim side — ally hits use taken preset, not attacker claw/slash. */
      targetKind?: "ally" | "enemy" | "structure" | "barrier";
      attackId?: string;
      /** Attacker→victim for impact angle (optional; charge hits may omit). */
      x0?: number;
      y0?: number;
      x1?: number;
      y1?: number;
    }
  | {
      type: typeof DfEvent.Destroy;
      id: string;
      x: number;
      y: number;
      kind: string;
    }
  | {
      type: typeof DfEvent.Supply;
      amount: number;
      messageKey: string;
    }
  | {
      type: typeof DfEvent.Beacon;
      messageKey?: string;
    }
  | {
      type: typeof DfEvent.DropFail;
      reason: DfDropReason;
      messageKey: string;
      amount?: number;
    }
  | { type: typeof DfEvent.Won; messageKey: string }
  | { type: typeof DfEvent.Lost; messageKey: string };
